var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-stage',{ref:"stage",attrs:{"config":_vm.stageSize}},[_c('v-layer',{ref:"layer"},[_c('v-regular-polygon',{ref:"hexagon",attrs:{"config":{
                x: 200,
                y: 200,
                sides: 6,
                radius: 70,
                fill: '',
                stroke: 'black',
                strokeWidth: 2
            }}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }